import { preview } from '@/components/form/preview'

import { Stack, Typography } from '@mui/material'
import { CheckCircleOutline } from '@workwave-tidal/core/icons'

import { useTexts } from '../../hooks/useTexts'

import { FieldPointsContainer } from './FieldPointsContainer'

interface Props {
  companyPhone: string
  showContactPhone: boolean
}

export function CompanyPhone(props: Props) {
  const { companyPhone, showContactPhone } = props

  const texts = useTexts()

  return (
    <preview.Field testId="trackingPage-companyPhone" label={texts.companyPhone}>
      <preview.Value variant="alternative">{companyPhone}</preview.Value>
      {showContactPhone && (
        <FieldPointsContainer>
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <CheckCircleOutline sx={{ fontSize: '16px', flexShrink: 0 }} color="primary" />
            <Typography variant="caption" lineHeight={1}>
              {texts.showContactPhone}
            </Typography>
          </Stack>
        </FieldPointsContainer>
      )}
    </preview.Field>
  )
}
